import { render, staticRenderFns } from "./nipo-script-widget.vue?vue&type=template&id=01f909aa"
import script from "./nipo-script-widget.vue?vue&type=script&lang=js"
export * from "./nipo-script-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports